
define('jquery-private', ['jquery', 'expose'], function ($, expose) {
    'use strict';

    return expose('$', $.noConflict(true), true);
});
